export default function useNavigateToExternalSite() {
    const navigateToExternalSite = (link) => {
        window.open(
            link,
            "_blank"
        );
    };

    return navigateToExternalSite;
}